import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollToDirective } from './scrollTo.directive';
import { ScrollToService } from './scrollTo.service';


export class ScrollToModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ScrollToModule
        };
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        ScrollToDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ScrollToDirective
    ],
    providers: [
        ScrollToService
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
